import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../../api.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-digital-courses-add',
  templateUrl: './college-courses-add.component.html',
  styleUrls: ['./college-courses-add.component.scss']
})
export class CollegeCourseComponent implements OnInit {

  public specializations = [];
  public streams = [];
  public courses = [];
  public colleges = [];
  public collegecourses = [];
  collegecoursesForm: FormGroup;
  public message:any = null;
  public class:any = null;
  submitted = false;
  isShown: boolean = false ;

  constructor(private router: Router, private api: ApiService, private formBuilder: FormBuilder, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public settings = {
    actions: {
      position: 'right',
      add: false
    },
    edit: {
      confirmSave: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      stream: {
        title: 'Streams'
      },
      course: {
        title: 'Courses'
      },
      specialization: {
        title: 'Specialization'
      },
      fees: {
        title: 'Fees'
      },
      seats: {
        title: 'Seats'
      },
      scholarship: {
        title: 'Scholarship'
      },
      scholarshipamt: {
        title: 'Scholarship Amount'
      },
      collegeid: {
        title: 'Collegeid',
        editable:false,
      },
    },
  };
  
  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void { }

  ngOnInit() {
    this.collegecoursesForm = this.formBuilder.group({
      specialization: ['', Validators.required],
      stream: ['', Validators.required],
      course: ['', Validators.required],
      fees: ['', Validators.required],
      seats: ['', Validators.required],
      scholarship: ['', Validators.required],
      // scholarshipamt: ['', Validators.required],
      collegeid: ['', Validators.required],
    }); 

    this.http.get<any>(this.api_endpoint+'/streams').subscribe(
        data => {
          this.streams = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
    this.http.get<any>(this.api_endpoint+'/colleges').subscribe(
        data => {
          this.colleges = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });

    this.http.get<any>(this.api_endpoint+'/collegecourses').subscribe(
        data => {
          this.collegecourses = data.data;
          // console.log(this.collegecourses);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  getcourses(value){

    this.http.get<any>(this.api_endpoint+'/coursess/' + value).subscribe(
        data => {
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  getspecialization(value){

    this.http.get<any>(this.api_endpoint+'/specializationc/' + value).subscribe(
        data => {
          // console.log(this.specializations);
          this.specializations = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  scholarshipamt(value){
    if(value == 'Enable'){
      this.isShown =  true;
    }else if(value == 'Disable'){
      this.isShown =  false;
    }
  }

  get f() { return this.collegecoursesForm.controls; }

  onFormSubmit() {
    this.submitted = true;

    if (this.collegecoursesForm.invalid) {
      return;
    }
    console.log(this.collegecoursesForm.value);
    this.http.post<any>(this.api_endpoint+'/collegecourses', this.collegecoursesForm.value).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        }
        window.location.reload();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  updateRecord(event) {
    // console.log(event.newData);
    var data = {
                "stream" : event.newData.stream,
                "course" : event.newData.course,
                "specialization" : event.newData.specialization,
                "fees" : event.newData.fees,
                "seats" : event.newData.seats,
                "scholarship" : event.newData.scholarship,
                "scholarshipamt" : event.newData.scholarshipamt,
                "_id" : event.newData._id,
                "collegeid" : event.newData.collegeid,
                };
        console.log(data);     
        this.http.put<any>(this.api_endpoint+'/collegecourses/', data).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          }
          event.confirm.resolve(event.newData);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }

}
